// extracted by mini-css-extract-plugin
module.exports = {"root":"_2apXFwjmElFZIFLf7tyA7F"};